import AddIcon from '@mui/icons-material/Add';
import React from 'react';
import { useAccountStore } from '../../../../../../components/Stores/accountStore';
import { useMaterialsStore } from '../../../../../../components/Stores/MaterialsStore';
import ButtonDesigned from '../../../../../../components/UI-Elements/Buttons/ButtonDesigned';
import { InputFieldWithTitles } from '../../../../../../components/UI-Elements/Select/InputFieldWithTitles';
import { OptionSelect } from '../../../../../../components/UI-Elements/Select/OptionSelect';
import { IProductMaterialInfo, Product } from '@sp-types/productType';
import { formatToPriceInDollars } from '../../../../../../utils/FormatValue';
import { getUnitObj } from '../../../../../../utils/MassUnits/massUnitsUtils';
import { useCurrencyRates } from '@hooks/useCurrencyRates';

interface Props {
  product: Product;
  setProduct: React.Dispatch<React.SetStateAction<Product>>;
}

export const ProductModifyMaterials: React.FC<Props> = ({ product, setProduct }) => {
  const { account, formulaColorDictionary } = useAccountStore();
  const { materialsMap } = useMaterialsStore();
  const { formulasToAccount } = account;
  const { pricesMap } = useCurrencyRates();
  const filteredMaterialsToAccount = formulasToAccount.filter((item) => item.formulaId !== 'general');

  const updateIngredient = (index: number, updates: Partial<IProductMaterialInfo>) => {
    setProduct({
      ...product,
      ingredients: product.ingredients.map((ingredient, idx) =>
        idx === index ? { ...ingredient, ...updates } : ingredient,
      ),
    });
  };

  return (
    <div className="flex flex-col gap-2 flex-1  ">
      <h6 className="text-red text-lg">{'Materials'}</h6>
      <div className="grid grid-cols-4 max-w-[50rem] gap-y-2 overflow-auto">
        <p className="col-span-2 ps-4 bg-gray-50 py-2  text-secondary ">Material</p>
        <p className="bg-gray-50 py-2 text-secondary ">Weight</p>
        <p className="bg-gray-50 py-2 text-secondary ">Price</p>
        {product.ingredients.map((item, index) => (
          <>
            <div
              style={{ borderLeft: `6px solid ${formulaColorDictionary[item.materialID]} ` }}
              className="col-span-2 ps-3  py-2 text-secondary border-y border-gray-150"
            >
              <div className="w-[15rem]">
                <OptionSelect
                  placeHolder="Set Material"
                  disabled={false}
                  currentOption={item.materialID}
                  isOptionDisabled={(value: string) =>
                    product.ingredients.map((item) => item.materialID).includes(value)
                  }
                  options={filteredMaterialsToAccount.map((item) => ({
                    text: materialsMap[item.formulaId].name,
                    value: item.formulaId,
                  }))}
                  setCurrentOption={(value: string) => updateIngredient(index, { materialID: value })}
                />
              </div>
            </div>
            <div className="  text-secondary border-y border-gray-150 flex flex-row items-center  gap-2">
              <div className="max-w-28">
                <InputFieldWithTitles
                  isNumeric={true}
                  isEditable={true}
                  changeValueFunc={(value: string | number) => {
                    if (+value >= 0) {
                      updateIngredient(index, {
                        weightInProduct: typeof value === 'number' ? value : parseFloat(value),
                      });
                    }
                  }}
                  value={item.weightInProduct}
                />
              </div>
              {getUnitObj(materialsMap[item.materialID]?.unit).shortForm}
            </div>
            <div className="py-2   border-y border-r border-gray-150 flex justify-between pe-2">
              {formatToPriceInDollars(pricesMap[item.materialID], 0)}
              <button
                className="text-blue-600 my-auto"
                onClick={() =>
                  setProduct({
                    ...product,
                    ingredients: [...product.ingredients.slice(0, index), ...product.ingredients.slice(index + 1)],
                  })
                }
              >
                <img src="../assets/icons/blue-flat/delete.svg" />
              </button>
            </div>
          </>
        ))}
      </div>
      <ButtonDesigned
        onButtonClick={() => {
          setProduct({
            ...product,
            ingredients: [
              ...product.ingredients,
              {
                materialID: filteredMaterialsToAccount[0].formulaId,
                weightInProduct: 0,
              },
            ],
          });
        }}
        style="outline"
        className="w-40"
      >
        <div className="flex flex-1 justify-between">
          <AddIcon /> <p className="my-auto"> Add Material</p>
        </div>
      </ButtonDesigned>
    </div>
  );
};
